import { render, staticRenderFns } from "./InitiativeDetail.vue?vue&type=template&id=7bbc388a"
import script from "./InitiativeDetail.vue?vue&type=script&lang=ts"
export * from "./InitiativeDetail.vue?vue&type=script&lang=ts"
import style0 from "./InitiativeDetail.vue?vue&type=style&index=0&id=7bbc388a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports